























import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import GExamCreateExamineeSettingSchoolClasses from '@/views/GExamCreate/ExamineeSetting/GExamCreateExamineeSettingSchoolClasses.vue';
import GExamCreateExamineeSettingStudents from '@/views/GExamCreate/ExamineeSetting/GExamCreateExamineeSettingStudents.vue';
import GVTag from '@/components/GVTag.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GExamCreateExamineeSetting',
  components: {
    GVTag,
    GExamCreateExamineeSettingStudents,
    GExamCreateExamineeSettingSchoolClasses,
  },
  computed: {},
  methods: {},
})
export default class GExamCreateExamieeSetting extends Mixins(GPageBase) {
  examineeSelectionType: GEnum.ExamineeSelectionType = GEnum.ExamineeSelectionType.Class;
  async mounted() {
    this.examineeSelectionType = examCreateModule.examineeSelectionType;
    //受検設定画面到達フラグをセット
    examCreateModule.setVisitExamineeSettingView(true);
  }

  @Watch('examineeSelectionType')
  handleExamineeSelectionType(value: GEnum.ExamineeSelectionType) {
    examCreateModule.setExamnieeSelectionType(value);
  }

  get isAssignStudent(): boolean {
    return examCreateModule.isAssignStudent;
  }

  get isAssignSchoolClass(): boolean {
    return examCreateModule.isAssignSchoolClass;
  }

  get selectionTypeStudent(): GEnum.ExamineeSelectionType {
    return GEnum.ExamineeSelectionType.Student;
  }

  get selectionTypeClass(): GEnum.ExamineeSelectionType {
    return GEnum.ExamineeSelectionType.Class;
  }

  get targetSelectedStudentCount(): number {
    return examCreateModule.assignedExamineeStudents.length;
  }

  get selectedSchoolClassCount(): number {
    return examCreateModule.selectedSchoolClassIDs.length;
  }

  get isValid(): boolean {
    return this.targetSelectedStudentCount > 0 || this.selectedSchoolClassCount > 0;
  }

  get evalSettingModeEdit(): boolean {
    return examCreateModule.evalSettingModeEdit;
  }

  handleClearExaminee() {
    examCreateModule.setExamnieeSelectionType(this.examineeSelectionType);
    examCreateModule.cleanSelectedStudents();
    if (!examCreateModule.evalSettingModeEdit) {
      examCreateModule.resetSchoolClassSelection(schoolClassModule.gradeSchoolClasses);
    }
  }
}
